import React from 'react';
import Button from '../../Input/Button/Button';

export const GenericButton = ({ text }) => (
    <span className="text text-generic">{text}</span>
);

export const RegisterButton = ({ onClick }) => (
    <Button
        type="solid"
        value="Register"
        class="default-btn"
        inputStyle="btn-input"
        onClick={onClick}
    />
);

export const AttendingButton = ({ isSingleEventPage, url }) => {
    const buttonText = isSingleEventPage ? 'You have registered' : 'Attending';

    if (!url) {
        return <GenericButton text={buttonText} />;
    }

    return (
        <a
            className="text text-registered"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
        >
            {buttonText}
        </a>
    );
};

export const InProgressButton = ({ isSingleEventPage, url }) => (
    <a
        className={`text text-purple ${
            isSingleEventPage ? 'text-registered' : ''
        }`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
    >
        {isSingleEventPage ? 'Go to event' : 'In progress: join now'}
    </a>
);

export const RegistrationClosedButton = () => (
    <GenericButton text="Registration closed" />
);

export const EventOverButton = () => <GenericButton text="Event is over" />;
